"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sticky = void 0;
class Sticky {
    static init() {
        const content = {
            '.inspiration': 40,
            '.single-product .summary': 400,
        };
        for (const key in content) {
            const elements = document.querySelectorAll(key);
            if (elements.length > 0) {
                for (let i = 0; i < elements.length; i++) {
                    elements[i].classList.add('element-' + i);
                    this.addStickyContent(key + '.element-' + i, content[key]);
                }
            }
        }
    }
    static addStickyContent(className, topValue) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const HcSticky = require('hc-sticky');
        if (className.includes('single-product')) {
            className = '';
        }
        new HcSticky(className + ' .stickyContent', {
            stickTo: className + ' .sticky-wrap',
            top: topValue,
            responsive: {
                992: {
                    disable: true,
                },
            },
        });
    }
}
exports.Sticky = Sticky;
